import { useState, useCallback } from 'react'

interface ToastOptions {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastOptions[]>([])

  const toast = useCallback((options: ToastOptions) => {
    // Em produção, mostrar visualmente
    // Por enquanto, usamos console ou alert
    if (options.variant === 'destructive') {
      console.error(`[Toast Error] ${options.title}: ${options.description}`)
    } else {
      console.log(`[Toast] ${options.title}: ${options.description}`)
    }
    
    // Fallback para alert em caso de erro crítico
    if (options.variant === 'destructive') {
      // alert(`${options.title}\n${options.description}`)
    }
    
    setToasts((prev) => [...prev, options])
    setTimeout(() => {
      setToasts((prev) => prev.slice(1))
    }, 3000)
  }, [])

  return { toast, toasts }
}

export default useToast
